<template>
  <div>
    <el-row class="search-add" :gutter="10">
      <el-col :span="4">
        <el-select v-model="model" placeholder="请选择整机型号" clearable>
          <el-option
            v-for="item in typeSelect"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-col>
      <el-col :span="4">
        <el-select-tree
          :options="categorySelect"
          placeholder="请选择产品分类"
          width="100%"
          :treeProps="treeProps"
          @handleNodeClick="selectDrop"
        />
      </el-col>
      <el-col :span="10">
        <el-button type="primary" icon="el-icon-search" @click="search"
          >搜索</el-button
        >
      </el-col>
      <el-col :span="2">
        <el-button type="success" @click="handleAdd">新增</el-button>
      </el-col>
    </el-row>

    <el-table :data="data" border stripe style="width: 100%">
      <el-table-column prop="create_time" label="创建时间"> </el-table-column>
      <el-table-column prop="name" label="整机名称"> </el-table-column>
      <el-table-column prop="model" label="整机型号"> </el-table-column>
      <el-table-column prop="categoryName" label="产品分类">
      <template slot-scope="scope">
        {{`${scope.row.categoryName}${scope.row.categoryPrefix}${scope.row.categoryCode}`}}
      </template>  
      </el-table-column>
      <el-table-column prop="description" label="整机描述"> </el-table-column>
      <el-table-column prop="application" label="应用场景"> </el-table-column>
      <el-table-column prop="lastModifyContent" label="最近修改记录"> </el-table-column>
      <el-table-column fixed="right" label="操作">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="Edit(scope.row)"
            >编辑</el-button
          >
          <el-button @click="Delete(scope.row)" type="text" size="small"
            >删除</el-button
          >
          <el-button @click="handleRecord(scope.row)" type="text" size="small"
            >修改记录</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <div class="tableDel-Page">
      <Pagination :params="pagin" @pageBind="getList"></Pagination>
    </div>
    <el-dialog
      :title="title"
      center
      :visible.sync="contentVisible"
      width="38%"
      @closed="handleClose"
    >
      <el-form
        :model="contentForm"
        ref="contentForm"
        label-width="100px"
        :rules="contentRules"
      >
        <el-form-item label="整机名称" prop="name">
          <el-input placeholder="请输入" v-model="contentForm.name"></el-input>
        </el-form-item>
        <el-form-item label="产品分类" prop="categoryId">
          <el-select-tree
            :options="categorySelect"
            placeholder="请选择产品分类"
            width="100%"
            :defaultData="defaultValue"
            :treeProps="treeProps"
            v-model="contentForm.categoryId"
            @handleNodeClick="selectDrop"
          />
        </el-form-item>
        <el-row :gutter="20">
          <el-col :span="17">
            <el-form-item label="整机编号" prop="code">
              <el-input
                placeholder="请输入"
                v-model="contentForm.code"
                type="number"
                :disabled="title !== '新增'"
              ></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="2" v-if="title === '新增'"
            ><el-button type="primary" size="small" @click="handleCode"
              >选择编号</el-button
            ></el-col
          >
        </el-row>

        <el-form-item label="整机型号" prop="model">
          <el-input
            placeholder="请输入"
            :disabled="true"
            v-model="contentForm.model"
          ></el-input>
        </el-form-item>
        <el-form-item label="应用场景" prop="application">
          <el-input
            placeholder="请输入"
            v-model="contentForm.application"
          ></el-input>
        </el-form-item>
        <el-form-item label="整机描述" prop="description">
          <el-input
            placeholder="请输入"
            v-model="contentForm.description"
          ></el-input>
        </el-form-item>
        <template v-if="title == '编辑'">
          <el-form-item label="修改内容" prop="remark">
            <el-input
              placeholder="请输入"
              v-model="contentForm.remark"
            ></el-input> </el-form-item
        ></template>

        <el-form-item>
          <el-button type="primary" @click="submitForm('contentForm')"
            >提交</el-button
          >
          <el-button @click="resetForm('contentForm')">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog title="修改记录" :visible.sync="open" @close="closeDailog">
      <el-row class="search-add" :gutter="10">
        <el-col :span="12"> 整机名称：{{ editData.name }} </el-col>
        <el-col :span="12"> 整机型号：{{ editData.model }} </el-col>
      </el-row>
      <el-table :data="recordData" border stripe style="width: 100%">
        <el-table-column type="index" width="50" label="序号">
        </el-table-column>
        <el-table-column property="operation_time" label="修改时间" width="120">
        </el-table-column>
        <el-table-column prop="desc" label="修改内容"> </el-table-column>
        <el-table-column fixed="right" label="操作">
          <template slot-scope="scope">
            <el-button type="text" size="small"@click="onExportLogPdf(scope.row.moduleId, 1)" >预览</el-button>
            <el-button @click="onExportLogPdf(scope.row.moduleId, 2)" type="text" size="small">下载PDF</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="tableDel-Page">
        <el-pagination
          :current-page="recordPagin.pageNum"
          :page-size="recordPagin.pageSize"
          layout="prev, pager, next"
          :total="recordPagin.total"
          @current-change="handleCurrentChange"
        >
        </el-pagination>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeDailog">关闭</el-button>
      </div>
    </el-dialog>

    <el-dialog title="编号列表" :visible.sync="openCode" @close="closeCodeDailog">
      <el-row class="search-add" :gutter="10">
        <el-col :span="12">
          最小值：{{
            codeData && codeData.unusedCodes && codeData.unusedCodes[0]
          }}
        </el-col>
        <el-col :span="12"> 最大值：{{ codeData && codeData.maxCode }} </el-col>
      </el-row>
      <el-radio-group class="radio_group_column" v-model="radio">
        <el-radio v-for="item in codeData.fullCodes" :label="item" :key="item"
          ><span :class="{ used: isUsed(item) }">{{ item }}</span></el-radio
        >
      </el-radio-group>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="addRadio">选择</el-button>
        <el-button @click="closeCodeDailog">取消</el-button>
      </div>
    </el-dialog>
    <el-dialog title="预览" :visible.sync="openPdf" @close="closePdfDailog" fullscreen="true">
      <iframe :src="pdfUrl" width="100%" height="600px"></iframe>
    </el-dialog>
  </div>
</template>

<script>
import Pagination from "@/components/Pagination";
import elSelectTree from "../../../components/SelectTree.vue";
var attributes = {
  //定义数据属性名称
  id: "id",
  parentId: "parentId",
  name: "categoryName",
  rootId: 0,
};
export default {
  data() {
    return {
      openCode: false,
      title: "新建",
      contentVisible: false,
      model: "",
      category: "",
      open: false,
      openPdf: false,
      recordData: [],
      editData: {},
      defaultValue: {},
      pdfUrl: "",
      radio: "",
      recordPagin: {
        pageNum: 1,
        pageSize: 20,
        total: 0,
      },
      treeProps: {
        value: "id",
        children: "children",
        label: "label",
      },
      codeData: {},
      data: [],
      categorySelect: [],
      originSelect: [],
      typeSelect: [],
      contentForm: {
        name: "",
        categoryId: "",
        code: "",
        model: "",
        application: "",
        description: "",
        remark: "",
      },
      pagin: {
        pageNum: 1,
        pageSize: 20,
        total: 0,
      },
      contentRules: {
        name: [{ required: true, message: "请输入", trigger: "blur" }],
        categoryId: [{ required: true, message: "请选中", trigger: "blur" }],
        code: [{ required: true, message: "请输入", trigger: "blur" }],
        model: [{ required: true, message: "请输入", trigger: "blur" }],
      },
    };
  },
  mounted() {
    this.getCategory();
    this.$http
      .post("/manage/machine/page", {
        pageNum: 1,
        pageSize: 99999,
      })
      .then((results) => {
        const filterValue = results["data"]["data"]["records"].map((i) => {
          return {
            value: i.model,
            label: i.model,
          };
        });
        this.typeSelect = filterValue;
      });
  },
  // 监听表单变化，自动生成整机型号
  watch: {
    contentForm: {
      handler() {
        const filterValue = this.originSelect.filter(i => i.id === this.category.id);
        if (!!filterValue.length && this.contentForm.code) {
          this.contentForm.model = `${filterValue[0].categoryPrefix}${this.contentForm.code}`;
        }
      },
      deep: true,
    },
  },
  methods: {
    closePdfDailog() {
      this.openPdf = false
    }, 
    onExportLogPdf(moduleId, type) {
      let params = {
        pageNum: 1,
        pageSize: 99999,
        moduleId
      };
      this.$http.post("/manage/machine/exportLogPdf", params, {responseType: 'blob'}).then((res) => {
       const url = window.URL.createObjectURL(new Blob([res.data], { type: 'application/pdf' }));
       if(type === 1) {
        this.openPdf = true;
        this.pdfUrl = url; 
       }
       if(type === 2) {
        const link = document.createElement('a');
       link.href = url;
       link.download = `${moduleId}.pdf`;
       document.body.appendChild(link);
       link.click();
       document.body.removeChild(link);
       }
      
      });
    },
    isUsed(item) {
      return this.codeData.usedCodes.includes(item);
    },
    addRadio() {
      this.openCode = false;
      this.$set(this.contentForm, "code", this.radio);
    },
    closeCodeDailog() {
      this.openCode = false;
    },
    handleCode() {
      this.openCode = true;
    },
    handleCurrentChange(val) {
      this.recordPagin.pageNum = val;
      this.getRecordList();
    },
    selectDrop(val) {
      console.log("选中---->", val);
      this.category = val;
      this.contentForm.categoryId = val.id;
    },
    search() {
      //搜索
      this.pagin.pageNum = 1;
      this.getList();
    },
    handleAdd() {
      this.title = "新增";
      this.contentVisible = true;
      this.contentForm = {};
      this.$http.post("/manage/code/getCodeDistribution").then((res) => {
        if (res.data.code === 0) {
          this.codeData = res.data.data;
        } else {
          this.$message({
            message: res.data.message,
            type: "error",
          });
        }
      });
    },
    handleClose() {
      this.contentVisible = false;
      this.contentForm = {};
      this.defaultValue = {};
    },
    getCategory() {
      //数据绑定
      let params = {
        pageNum: 1,
        pageSize: 99999,
      };
      this.$http.post("/manage/category/page", params).then((results) => {
        const value = results["data"]["data"]["records"];
        this.originSelect = [...value];
        this.categorySelect = this.tree(value, attributes);
      });
    },
    getList() {
      //数据绑定
      let params = {
        pageNum: this.pagin.pageNum,
        pageSize: this.pagin.pageSize,
      };
      if (this.model) {
        params.model = this.model;
      }
      if (this.category) {
        params.categoryId = this.category.id;
      }
      this.$http.post("/manage/machine/page", params).then((results) => {
        const cloneValue =  results["data"]["data"]["records"];
        this.data = cloneValue;
        this.pagin.total = results["data"]["data"]["total"];
      });
    },
    Edit(data) {
      this.contentVisible = true;
      this.title = "编辑";
      const cloneValue = JSON.parse(JSON.stringify(data));
      this.contentForm = cloneValue;
      const filteredValue = {
        id: data.categoryId,
        label: `${data.categoryName}${data.categoryPrefix}${data.categoryCode}`,
      };
      this.category = filteredValue;
      this.defaultValue = filteredValue;
    },
    Delete(data) {
      //单删
      if (confirm("确认要删除吗？")) {
        this.$http
          .post("/manage/machine/delete", {
            id: data.id,
          })
          .then((res) => {
            if (res.data.code === 0) {
              this.getList();
              this.$message({
                message: "删除成功",
                type: "success",
              });
            } else {
              this.$message({
                message: res.data.message,
                type: "error",
              });
            }
          });
      }
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        console.log(this.contentForm);
        if (valid) {
          this.$http
            .post("/manage/machine/save", this.contentForm)
            .then((res) => {
              if (res.data.code === 0) {
                this.category = {};
                this.contentForm.categoryId = "";
                this.getList();
                this.$refs[formName].resetFields();
                this.contentVisible = false;
                this.$message({
                  message: "操作成功",
                  type: "success",
                });
              } else {
                this.$message({
                  message: res.data.message,
                  type: "error",
                });
              }
            });
        }
      });
    },
    resetForm(formName) {
      this.contentVisible = false;
      this.$refs[formName].resetFields();
      this.contentForm.categoryId = "";
      this.defaultValue = {};
      this.category={};
    },
    closeDailog() {
      this.open = false;
      this.contentForm.categoryId = "";
      this.defaultValue = {};
      this.category={};
    },
    handleRecord(data) {
      this.editData = data;
      this.open = true;
      this.getRecordList();
    },
    getRecordList() {
      const params = {
        pageNum: this.recordPagin.pageNum,
        pageSize: this.recordPagin.pageSize,
        moduleId: this.editData.id,
      };
      this.$http.post("/manage/machine/log", params).then((res) => {
        this.recordData = res["data"]["data"]["records"];
        this.recordData.total = res["data"]["data"]["total"];
      });
    },
    tree(data, attributes) {
      let resData = data;
      let tree = [];
      for (let i = 0; i < resData.length; i++) {
        if (resData[i][attributes.parentId] === attributes.rootId) {
          let obj = {
            id: resData[i][attributes.id],
            label: resData[i][attributes.name],
            data: resData[i],
            children: [],
          };
          if (resData[i].categoryPrefix && resData[i].categoryCode) {
            obj.label = `${obj.label}${resData[i].categoryPrefix}${resData[i].categoryCode}`;
          }
          tree.push(obj);
          resData.splice(i, 1);
          i--;
        }
      }
      run(tree);

      function run(chiArr) {
        if (resData.length !== 0) {
          for (let i = 0; i < chiArr.length; i++) {
            for (let j = 0; j < resData.length; j++) {
              if (chiArr[i].id == resData[j][attributes.parentId]) {
                let obj = {
                  id: resData[j][attributes.id],
                  label: resData[j][attributes.name],
                  children: [],
                  data: resData[j],
                };
                if (resData[j].categoryPrefix && resData[j].categoryCode) {
                  obj.label = `${obj.label}${resData[j].categoryPrefix}${resData[j].categoryCode}`;
                }
                chiArr[i].children.push(obj);
                resData.splice(j, 1);
                j--;
              }
            }
            run(chiArr[i].children);
          }
        }
      }
      return tree;
    },
  },
  components: { Pagination, elSelectTree },
};
</script>

<style scoped>
.used {
  color: red !important; 
}
.radio_group_column {
  display: flex;
  flex-direction: column;
  margin-left: 10px;
  max-height: 300px;
  overflow-y: auto;
}
.radio_group_column label {
  margin-bottom: 10px;
}
</style>
